export default function threatDetection() {
  const threatDetectionContainer = $(".threat-detection-container");
  if (!threatDetectionContainer.length) return;

  $(window).on("scroll", function () {
    var threatDetectionTriggered = false;
    var scrollTop = $(window).scrollTop(),
      windowHeight = $(window).height(),
      elem = threatDetectionContainer.offset().top,
      final = elem - windowHeight,
      distance = final - scrollTop;

    if (
      threatDetectionContainer.length &&
      !threatDetectionTriggered &&
      distance < 0
    ) {
      $(".user-score-value-bar").each(function () {
        var $bar = $(this);
        var val = parseInt($bar.data("bar-val")) || 0;
        var max = parseInt($bar.data("bar-max")) || 100;

        var percentage = (val / max) * 100;
        $bar.css("--bar-width", percentage + "%");

        if (percentage < 30) {
          $bar.addClass("score-low");
        } else if (percentage < 70) {
          $bar.addClass("score-medium");
        } else {
          $bar.addClass("score-high");
        }

        setTimeout(function () {
          $bar.addClass("animated");
        }, 100);
      });

      threatDetectionTriggered = true;
    }
  });
}
